import { SxProps, Typography } from "@mui/material";

type Props = {
  sx?: SxProps;
};

export const Pix4DTXT = (props: Props) => {
  return (
    <Typography
      gutterBottom
      variant="body2"
      component="div"
      sx={{
        marginTop: "6px",
        marginBottom: "6px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        height: "20px",
        userSelect: "none",
      }}
    >
      Powered by Pix4D
    </Typography>
  );
};
